export const environment = {
  API_URL: 'https://us-central1-festivali.cloudfunctions.net',
  projectId: '4e17YfYSZVMhzJev5WCey',
  API_URL_MOBILE: 'https://festivali-app.web.app/',
  firebase: {
    apiKey: 'AIzaSyDpyLPF1EDqRIgYP2O9DavPhw-Ccb78aEM',
    authDomain: 'festivali.firebaseapp.com',
    projectId: 'festivali',
    storageBucket: 'festivali.appspot.com',
    messagingSenderId: '833342568135',
    appId: '1:833342568135:web:e817698ce439777901b0e2',
    measurementId: 'G-ZSFGWRTR64',
  },
};
